import { render, staticRenderFns } from "./mo-address-auto-form.html?vue&type=template&id=5d1b5eec&external"
import script from "./mo-address-auto-form.ts?vue&type=script&lang=ts&external"
export * from "./mo-address-auto-form.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-address-auto-form.vue?vue&type=style&index=0&id=5d1b5eec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports